// İSG Portal — paylaşılan saha bağlamı (site context) store'u (S34-3, design review
// `S34-carbon-phase2-plan.md` §3 M4). `apps/web-expert/src/lib/securitySiteStorage.ts`'in
// (S32 tasarım spec'i §4 [P]: "a gate does not change site") TERFİSİ — Güvenlik masasının
// "son seçili saha" tercihi artık BURADA, tek bir zustand store'da yaşar, ikinci bir tüketici
// (Panel'in kendi saha seçicisi, S34-4) AYNI durumu okuyup yazabilsin diye.
//
// Yalnız `{ uuid, name }` — KVKK anlamında PII TAŞIMAZ (saha adı zaten firmanın genel bilgisi,
// `securitySiteStorage.ts`'in eski dosya başlığıyla AYNI gerekçe).
//
// **`site: null` çağırana göre İKİ ayrı anlam taşır, bu store ikisini AYIRT ETMEZ:** Güvenlik
// masası için "henüz seçilmedi" (kullanıcı bir `Select` ile seçmek ZORUNDA — S32 §8.5 "no
// silent first-site auto-select", saha listesine göre doğrulama SecurityDeskPage'in kendi işi,
// bkz. o dosya); Panel için (S34-4, henüz YAZILMADI) geçerli bir SEÇENEK olarak "tüm sahalar".
// Anlamı çözmek çağıranın (sayfanın) sorumluluğu — tıpkı bugün `SecurityDeskPage`'in `sites`
// listesine göre kendi geçerlilik kontrolünü yapması gibi.
//
// **Anahtar `principal.uuid`e göre ayrılır (güvenlik düzeltmesi, S34-3 sonrası review).**
// Eski, TERFİ ÖNCESİ hâli (`securitySiteStorage.ts`) ve bu dosyanın İLK S34-3 sürümü TEK, GLOBAL
// bir anahtar kullanıyordu (`isgportal.security.lastSite`) — aynı tarayıcıda ardışık oturum açan
// İKİ FARKLI kullanıcı (paylaşılan bir gate PC'sinde tam da beklenen senaryo) birbirinin son
// seçtiği sahayı DEVRALIRDI, çıkıştan sonra bile. `uiPrefs.ts`'teki `useTableDensity`/
// `useNavRailCollapsed` ile AYNI desen: anahtar `isgportal.security.${uuid}.lastSite`, `uuid`
// `useAuthStore`'dan SENKRON (JWT'den çözülmüş) — `useMe` DEĞİL. Store BİR ADIM farklı: bu bir
// `useState` DEĞİL, birden çok bileşenin PAYLAŞTIĞI tek bir zustand store'u, bu yüzden `uuid`
// değişimini (giriş/kullanıcı değişimi) karşılayan `hydrate` bir `useEffect` İÇİNDE çağrılır
// (aşağıdaki `useSiteContext` hook'u) — render SIRASINDA bir DIŞ store'u `set` etmek (saf
// olmayan render) YERİNE. `SecurityDeskPage` zaten kendi `selectedSite`ini `sites`e karşı bir
// `useEffect`te doğruluyor (bkz. o dosya) — bu store da AYNI "bir tık sonra yerine oturur"
// desenine uyar, YENİ bir sıçrama İCAT ETMEZ.
//
// **Çıkışta BELLEKTEKİ durum ayrıca senkron temizlenir (`clearSiteContext`, `AppHeader.tsx`'in
// `onLogout`u çağırır).** Yalnız anahtarı `uuid`e göre ayırmak YETMEZ: çıkış sayfayı `/login`e
// NAVIGATE eder, `SecurityDeskPage` (ve onun `useSiteContext` hook çağrısı, dolayısıyla
// `hydrate` efekti) o anda ZATEN UNMOUNT olabilir — hiçbir mounted tüketici `uuid`nin `null`a
// düştüğünü GÖZLEMLEMEZ, store'un belleği KENDİLİĞİNDEN temizlenmez. `queryClient.clear()`
// (AYNI `onLogout`, AYNI gerekçe — web-supplier `AppHeader.tsx`'teki S17 bulgusuyla birebir
// mirror) ile AYNI desen: açık, senkron bir çağrı.
//
// **Web-özel** (`window.localStorage` DOĞRUDAN) — mobil-manager'ın import ZİNCİRİ bu dosyaya
// UĞRAMAZ: yalnız ana barrel'dan (`index.ts`) dışa aktarılır, `core.ts`'DEN DEĞİL (mobil yalnız
// `@isgportal/shared/core` import eder, `auth/store.ts`'in dosya başlığındaki gibi bir platform
// depolama enjeksiyonu burada YOK — buna gerek de yok, çünkü bu store hiç mobile ULAŞMAZ).

import { useEffect } from 'react';
import { create } from 'zustand';
import { useAuthStore } from '../auth/store';

export interface SiteContextSite {
  uuid: string;
  name: string;
}

function storageKey(principalUuid: string): string {
  return `isgportal.security.${principalUuid}.lastSite`;
}

function readStoredSite(principalUuid: string): SiteContextSite | null {
  try {
    const raw = window.localStorage.getItem(storageKey(principalUuid));
    if (!raw) {
      return null;
    }
    const parsed: unknown = JSON.parse(raw);
    if (
      parsed &&
      typeof parsed === 'object' &&
      typeof (parsed as SiteContextSite).uuid === 'string' &&
      typeof (parsed as SiteContextSite).name === 'string'
    ) {
      return parsed as SiteContextSite;
    }
    return null;
  } catch {
    return null;
  }
}

function writeStoredSite(principalUuid: string, site: SiteContextSite | null): void {
  try {
    if (site) {
      window.localStorage.setItem(storageKey(principalUuid), JSON.stringify(site));
    } else {
      window.localStorage.removeItem(storageKey(principalUuid));
    }
  } catch {
    // Depolama kullanılamıyor (gizli mod/kota) — sessizce yok say, seçim bu oturumda çalışmaya devam eder.
  }
}

interface SiteContextStoreState {
  /** BU durumun ait olduğu kullanıcı — `null` = henüz hiç `hydrate` edilmedi ya da oturum yok.
   * Yalnız `hydrate`in kendi idempotent koruması için; tüketiciler doğrudan okumaz. */
  uuid: string | null;
  site: SiteContextSite | null;
  /** `uuid` değiştiğinde (dosya başlığı notu) o kullanıcının kalıcılaştırılmış seçimine geçer.
   * `uuid === null` iken temizler (oturum yok → kalıcı seçim de yok). İdempotent — zaten AYNI
   * `uuid`deyse hiçbir şey yapmaz (gereksiz `localStorage` okuması/`set` YOK). */
  hydrate: (uuid: string | null) => void;
  setSite: (site: SiteContextSite | null) => void;
  /** Dosya başlığındaki "çıkışta bellek temizliği" notu. */
  clear: () => void;
}

const useSiteContextStore = create<SiteContextStoreState>((set, get) => ({
  uuid: null,
  site: null,
  hydrate: (uuid) => {
    if (get().uuid === uuid) {
      return;
    }
    set({ uuid, site: uuid ? readStoredSite(uuid) : null });
  },
  setSite: (site) => {
    const { uuid } = get();
    if (uuid) {
      writeStoredSite(uuid, site);
    }
    set({ site });
  },
  clear: () => set({ uuid: null, site: null }),
}));

/**
 * Paylaşılan saha bağlamı — `useAuthStore`'un aktif `principal.uuid`'sine göre kullanıcı
 * BAŞINA kalıcı (dosya başlığı notu). `uuid` değişince (mount, giriş, kullanıcı değişimi) bir
 * `useEffect` içinde `hydrate` edilir — `SecurityDeskPage`'in kendi doğrulama efektiyle AYNI
 * "bir tık sonra yerine oturur" desenidir, render SIRASINDA dış bir store'u mutasyona
 * UĞRATMAZ.
 */
export function useSiteContext<T>(
  selector: (state: Pick<SiteContextStoreState, 'site' | 'setSite'>) => T,
): T {
  const uuid = useAuthStore((s) => s.principal?.uuid ?? null);
  useEffect(() => {
    useSiteContextStore.getState().hydrate(uuid);
  }, [uuid]);
  return useSiteContextStore(selector);
}

/**
 * Çıkışta BELLEKTEKİ saha seçimini senkron temizler (dosya başlığı notu) — `AppHeader.tsx`'in
 * `onLogout`u `queryClient.clear()` ile AYNI yerde, AYNI gerekçeyle çağırır.
 */
export function clearSiteContext(): void {
  useSiteContextStore.getState().clear();
}
